import React from 'react';
import ScrollAbleList from "../../Widgets/ScrollAbleList/ScrollAbleList";
import EqualWidthColumnStaticContent from "../../Widgets/EqualWidthColumnStaticContent/EqualWidthColumnStaticContent";
var css = {
  "container": "oalp-FcMF2",
  "card": "oalp-1Ws9U",
  "selected": "oalp-3xvmD",
  "disabled": "oalp-q4FVR"
};
import { ScrollAbleList as ScrollAbleListTemplateName, EQUAL_WIDTH_COLUMN_STATIC_CONTENT } from "../../Constants/templateName";
import { equalWidthColumnMetadataBrandSelection } from "../../Constants/buyerIntent";
var BrandSelection = function BrandSelection(_ref) {
  var brands = _ref.brands,
    metadata = _ref.metadata,
    name = _ref.name,
    list = _ref.list,
    title = _ref.title,
    icon = _ref.icon,
    handleFilterClick = _ref.handleFilterClick,
    appliedFilters = _ref.appliedFilters;
  var popularBrandsData = [];
  if (brands && Array.isArray(brands)) {
    brands.forEach(function (item) {
      var _item$icon_url = item.icon_url,
        icon_url = _item$icon_url === void 0 ? '' : _item$icon_url,
        _item$value = item.value,
        value = _item$value === void 0 ? '' : _item$value,
        count = item.count;
      var _cardStyle = '';
      var isSelected = !!(appliedFilters && appliedFilters.includes(value));
      if (count === 0) {
        _cardStyle = css.disabled;
      } else {
        _cardStyle = isSelected ? css.selected : '';
      }
      popularBrandsData.push({
        image: {
          alt: value,
          url: icon_url,
          style: {
            height: '32px',
            display: 'block',
            margin: 'auto',
            paddingTop: '14px'
          }
        },
        className: _cardStyle,
        isSelected: isSelected
      });
    });
  }
  var popularListData = [];
  if (list && Array.isArray(list)) {
    list.forEach(function (item) {
      var _item$id = item.id,
        id = _item$id === void 0 ? '' : _item$id,
        _item$name = item.name,
        name = _item$name === void 0 ? '' : _item$name,
        _item$count = item.count,
        count = _item$count === void 0 ? 0 : _item$count;
      var isSelected = !!(appliedFilters && appliedFilters.includes(id));
      var isPopular = !!brands.some(function (brand) {
        return brand.value === item.id;
      });
      if (!isPopular) {
        popularListData.push({
          id: id,
          name: name,
          count: count,
          isSelected: isSelected
        });
      }
    });
  }
  function handleBrandSelect(event) {
    var index = event.currentTarget.getAttribute('data-index');
    if (index && brands[parseInt(index, 10)].count > 0) {
      handleFilterClick(brands[parseInt(index, 10)]);
    }
  }
  function handleListSelect(event) {
    var index = event.currentTarget.getAttribute('data-index');
    var listIndex = index && list.findIndex(function (brand) {
      return brand.id === popularListData[parseInt(index, 10)].id;
    });
    if (listIndex) {
      handleFilterClick(list[listIndex]);
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: css.container
  }, /*#__PURE__*/React.createElement(EqualWidthColumnStaticContent, {
    classname: css.card,
    handleClick: handleBrandSelect,
    templateName: EQUAL_WIDTH_COLUMN_STATIC_CONTENT,
    data: popularBrandsData,
    metadata: equalWidthColumnMetadataBrandSelection,
    name: name,
    showObserver: false
  }), /*#__PURE__*/React.createElement(ScrollAbleList, {
    title: title,
    selectedItemIcon: icon,
    handleListSelect: handleListSelect,
    name: name,
    templateName: ScrollAbleListTemplateName,
    data: popularListData,
    metadata: metadata
  }));
};
export default BrandSelection;